export class DocumentFileModel {
    public id: number;
    public fileName: string;
}